import { useEffect, useState } from 'react';
import { apiRequest } from './api';

// What to show until GET /listings/count answers, and if it never does.
export const FALLBACK_LISTING_TOTAL = 1200;

/**
 * Jaakko's live listing total, for the surfaces that quote it as a number.
 *
 * The count is a marketing claim in two places now, and a hardcoded one goes
 * stale silently. Fetched once per mount; the endpoint caches for five minutes
 * server side, so a second caller costs a round trip and nothing more.
 */
export const useListingTotal = (): number => {
  const [total, setTotal] = useState(FALLBACK_LISTING_TOTAL);

  useEffect(() => {
    let cancelled = false;
    apiRequest('/listings/count')
      .then((data: { total?: number }) => {
        if (!cancelled && typeof data?.total === 'number' && data.total > 0) {
          setTotal(data.total);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return total;
};
